

export default {
    name: 'FearAndGreedIndex',

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            chartWidth: 0,
        }
    },

    computed: {
        chartImagePath() {
            return this.$vuetify.theme.dark ?
                require('@/assets/market-analysis/fear-and-greed-dark.png') :
                require('@/assets/market-analysis/fear-and-greed-light.png');
        },
        indicatorStyle() {
            return {
                transform: `rotate(${(this.data.current ?? 0) / 100 * 180}deg)`,
                width: `${this.chartWidth / 308 * 314}px`,
                left: `${-this.chartWidth / 308 * 4}px`,
                bottom: `${-this.chartWidth / 308 * 4}px`,
            }
        },
        dotStyle() {
            return {
                transform: `rotate(${(this.data.current ?? 0) / 100 * 180}deg)`,
                width: `${this.chartWidth / 308 * 28}px`,
                height: `${this.chartWidth / 308 * 28}px`,
                border: `${this.chartWidth / 308 * 8}px solid`,
            }
        },
        scoreStyle() {
            return {
                fontSize: `${this.chartWidth / 308 * 60}px !important`,
                lineHeight: `${this.chartWidth / 308 * 72}px`,
            }
        }
    },

    watch: {
        data: {
            immediate: true,
            deep: true,
            handler() {
                this.calculateChart()
            }
        }
    },

    mounted() {
        window.addEventListener('resize', this.calculateChart)
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.calculateChart)
    },

    methods: {
        calculateChart() {
            const width = this.$refs.chart?.getBoundingClientRect().width ?? 0

            this.chartWidth = width
        },
        getIndexText(score) {
            if (score < 20) {
                return this.$t('component.fearAndGreedIndex.extremeFear')
            } else if (score < 40) {
                return this.$t('component.fearAndGreedIndex.fear')
            } else if (score < 60) {
                return this.$t('component.fearAndGreedIndex.neutral')
            } else if (score < 80) {
                return this.$t('component.fearAndGreedIndex.greed')
            } else {
                return this.$t('component.fearAndGreedIndex.extremeGreed')
            }
        },
        getColorClass(score) {
            if (score < 20) {
                return 'red-500';
            } else if (score < 40) {
                return 'red-300'
            } else if (score < 60) {
                return 'purple-500'
            } else if (score < 80) {
                return 'blue-300'
            } else {
                return 'blue-500';
            }
        },
        getBgColorClass(score) {
            if (score < 20) {
                return 'bg-red-500';
            } else if (score < 40) {
                return 'bg-red-300'
            } else if (score < 60) {
                return 'bg-purple-500'
            } else if (score < 80) {
                return 'bg-blue-300'
            } else {
                return 'bg-blue-500';
            }
        },
        getIndicatorShadowClass(score) {
            if (score < 20) {
                return 'red-500 shadow-red-500';
            } else if (score < 40) {
                return 'red-300 shadow-red-300'
            } else if (score < 60) {
                return 'purple-500 shadow-purple-500'
            } else if (score < 80) {
                return 'blue-300 shadow-blue-300'
            } else {
                return 'blue-500 shadow-blue-500';
            }
        },
    },
}
